import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Utils } from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import { ReactComponent as LeftArrow } from 'Assets/svg/left-arrow.svg';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { ReactComponent as ContactNameIcon } from 'Assets/svg/contact-name.svg';
import { ReactComponent as CompanyNameIcon } from 'Assets/svg/company-name.svg';
import { ReactComponent as ContactTitleIcon } from 'Assets/svg/contact-title.svg';
import { personalisedOnboardingState } from 'Stores/personalisedOnboardingState';
import ProspectorStarterIcon from 'Assets/png/personalised_onboarding/singleNoData.png';

import InputTextBox from 'Components/common/InputTextBox';
import { InputBoxWithSuggestionSingleSelect } from 'Pages/advancedSearch/shared-component/inputBoxWithSuggestionSingleSelect';
import { advSearchFilterPopupState } from 'Stores/advSearchFIlterPopup';
import Button from '../common/Button';

const {
  EXTERNAL_LINKS,
  PERSONALIED_ONBOARDING_FLOWS,
  MX_PERSONALISED_ONBOARDING_EVENTS,
} = CONSTANTS;
const { STARTER_FLOW } = PERSONALIED_ONBOARDING_FLOWS;
const {
  LB_GOAL_CURRENT_STEP_VALUE,
  LB_GOAL_COMPLETE,
} = MX_PERSONALISED_ONBOARDING_EVENTS;
const {
  SEARCH_INITIATED,
  NO_RESULTS,
  AP_LINK_CLICKED,
} = LB_GOAL_CURRENT_STEP_VALUE;

const OnboardingSingleContactPopup = observer(props => {
  const [contactName, setContactName] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [contactTitle, setContactTitle] = useState('');
  const [error, setError] = useState('');
  const [companyNameItems, setCompanyNameItems] = useState([]);
  const [noMatchFound, setNoMatchFound] = useState(false);
  const [noResultFound, setNoResultFound] = useState(false);
  const [searchResultLoading, setSearchResultLoading] = useState(false);
  const [
    companyNameSuggestionLoading,
    setCompanyNameSuggestionLoading,
  ] = useState(false);
  const { isPersonalisedOnboardingFlow } = personalisedOnboardingState;
  const eventName = Utils.personalisedOnboardingEventMap(
    isPersonalisedOnboardingFlow,
  );

  const contactNameChange = (id, value) => {
    setError(null);
    setContactName(value);
  };

  const contactTitleChange = (id, value) => {
    setContactTitle(value);
  };
  const validateInput = () => {
    let validationSuccess = false;
    setError(null);
    if (contactName === '' || companyName === '')
      setError('Please fill in the mandatory fields before moving forward.');
    else validationSuccess = true;
    return validationSuccess;
  };

  const generateCompanyNameListSearchArr = (list = []) => {
    if (list?.length) {
      const newList = list.map((item, index) => {
        const newObj = {};
        const { name, domain } = item;
        newObj.pName = domain;
        newObj.orgName = name;
        newObj.name = domain;
        newObj.displayName = `${domain} - ${name}`;
        return newObj;
      });
      return newList;
    }
    return [];
  };

  const companyNameChange = async inputVal => {
    setCompanyName(inputVal);
    setCompanyNameItems([]);
    setNoMatchFound(false);
    setError(null);

    setCompanyNameSuggestionLoading(true);
    const response = await personalisedOnboardingState.getCompanyNameSuggestion(
      inputVal,
    );
    const { data = [], message = null } = response;
    if (message === 'cancel') {
      console.log('do nothing');
    } else if (inputVal !== '') {
      setCompanyNameSuggestionLoading(false);
      const listData = generateCompanyNameListSearchArr(data);

      if (listData.length === 0) setNoMatchFound(true);
      else setCompanyNameItems(listData);
    } else {
      setCompanyNameSuggestionLoading(false);
    }
  };

  const handleOnSelect = item => {
    const { name } = item;
    setCompanyName(name);
    setCompanyNameItems([]);
  };

  const handleOnbStepClick = async (e, key) => {
    if (validateInput()) {
      advSearchFilterPopupState.clearAllFilters();
      advSearchFilterPopupState.setAppliedFilters(
        'companyName',
        [companyName],
        null,
        false,
        false,
      );
      advSearchFilterPopupState.setAppliedFilters(
        'name',
        [contactName],
        null,
        false,
        false,
      );
      advSearchFilterPopupState.setAppliedFilters(
        'title',
        [contactTitle],
        null,
        false,
        false,
      );

      setSearchResultLoading(true);
      const searchQuery = {
        companyName: [companyName],
        name: [contactName],
        title: [contactTitle],
      };

      if (eventName) {
        Utils.mixpanelTrack(eventName, {
          currentStep: SEARCH_INITIATED,
          searchQuery,
          searchQueryStr: JSON.stringify(searchQuery),
        });
        Utils.mixpanelTrack(LB_GOAL_COMPLETE, {
          goalName: eventName,
          currentStep: SEARCH_INITIATED,
          searchQuery,
          searchQueryStr: JSON.stringify(searchQuery),
        });
      }

      const resp = await advSearchFilterPopupState.returnSearchResults();
      setSearchResultLoading(false);
      const { data } = resp;
      if (data && data?.contacts && data?.contacts?.length > 0) {
        advSearchFilterPopupState.applyPopupFilters();
        props.history.push('/advanced-search/contact#search');
        personalisedOnboardingState.setIsOnboardingGuideFlow(false);
        personalisedOnboardingState.clearOnboardingFlow();
      } else {
        if (eventName)
          Utils.mixpanelTrack(eventName, {
            currentStep: NO_RESULTS,
            searchQuery,
            searchQueryStr: JSON.stringify(searchQuery),
          });
        setNoResultFound(true);
      }
    }
  };

  const handleSubmitKeyboardAction = event => {
    if (event.keyCode === 13) handleOnbStepClick();
  };

  const handleBackClick = () => {
    if (noResultFound) {
      setNoResultFound(false);
      setContactName('');
      setCompanyName('');
      setContactTitle('');
      setCompanyNameItems([]);
    } else {
      personalisedOnboardingState.setOnboardingCurrentStep(0);
      personalisedOnboardingState.setIsPersonalisedOnboardingFlow(STARTER_FLOW);
    }
    if (eventName)
      Utils.mixpanelTrack(eventName, {
        navigateBack: noResultFound ? NO_RESULTS : SEARCH_INITIATED,
      });
  };

  const handleCloseClick = () => {
    if (eventName)
      Utils.mixpanelTrack(eventName, {
        closed: noResultFound ? NO_RESULTS : SEARCH_INITIATED,
      });
    personalisedOnboardingState.clearOnboardingFlow();
  };

  const handleChromePluginLinkClick = () => {
    if (eventName)
      Utils.mixpanelTrack(eventName, {
        currentStep: AP_LINK_CLICKED,
      });
    Utils.openNewTab(EXTERNAL_LINKS.PROSPECTOR.CHROME_STORE_FIND_WEBSITE_LINK);
  };
  return (
    <div className="onboarding-flow-popup onboarding-single-contact-flow">
      <div className="close-icon-wrapper">
        <CloseIcon className="close-icon" onClick={e => handleCloseClick()} />
      </div>
      <div className="onboarding-header">
        <div className="title">
          Hey <span className="name">{Utils.getUserName()}</span>, Welcome
          aboard!{' '}
          <span role="img" aria-label="tata">
            🎉
          </span>
        </div>
      </div>
      <div className="onboarding-bg-wrapper">
        <div className="hint-title">
          <div className="arrow-wrapper" onClick={e => handleBackClick()}>
            <LeftArrow className="onb-arrow-icon right-arrow" />
          </div>
          Quickly find a prospect&apos;s data
        </div>
        <span>
          {!noResultFound ? (
            <>
              <div className="filter-group-wrapper">
                <div className="input-wrapper">
                  <ContactNameIcon className="svg-info-icon" />
                  <InputTextBox
                    name="contactName"
                    id="contactName"
                    value={contactName}
                    change={contactNameChange}
                    cbk={e => handleSubmitKeyboardAction(e)}
                    placeHolder="Name*"
                  />
                </div>
                <div className="input-wrapper">
                  <CompanyNameIcon className="svg-info-icon" />
                  <InputBoxWithSuggestionSingleSelect
                    inputVal={companyName}
                    placeholder="Company Name*"
                    setInputVal={companyNameChange}
                    suggestionList={companyNameItems}
                    noMatchFound={noMatchFound}
                    setNoMatchFound={setNoMatchFound}
                    handleOnSelect={handleOnSelect}
                    suggestionKey="company-name"
                    isSuggestionLoading={companyNameSuggestionLoading}
                    {...props}
                  />
                </div>
                <div className="input-wrapper">
                  <ContactTitleIcon className="svg-info-icon" />
                  <InputTextBox
                    name="contactTitle"
                    id="contactTitle"
                    value={contactTitle}
                    change={contactTitleChange}
                    cbk={e => handleSubmitKeyboardAction(e)}
                    placeHolder="Title"
                  />
                </div>

                {error && <div className="error-wrapper">{error}</div>}
              </div>
              <div className="button-wrapper">
                <Button
                  btnText="Search"
                  icon={false}
                  iconName=""
                  type="button"
                  className={`action-btn ${
                    searchResultLoading ? ' loading' : ''
                  }`}
                  loader={searchResultLoading}
                  click={e => handleOnbStepClick(e)}
                />
              </div>
            </>
          ) : (
            <div className="use-prospector-wrapper">
              <div className="img-wrapper">
                <img src={ProspectorStarterIcon} alt="ProspectorStarterIcon" />
              </div>
              <div className="title">Oops!</div>
              <div className="sec-title">
                {`We weren't able to find ${contactName}.`}
              </div>
              <div className="sec-info-title">
                {`You can still get ${contactName}'s details following these steps -`}
              </div>
              <ol>
                <li>
                  {`Find ${contactName} on Linkedin using chrome web browser.`}
                </li>
                <li>
                  Download/open Adapt&apos;s prospector{' '}
                  <div
                    className="link"
                    onClick={e => handleChromePluginLinkClick()}
                  >
                    chrome plugin
                  </div>
                  .
                </li>
                <li>
                  Launch the plugin on the{' '}
                  <a
                    href="https://www.linkedin.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    linkedin page
                  </a>{' '}
                  and you should be able to get the details.
                </li>
              </ol>
            </div>
          )}
        </span>
      </div>
    </div>
  );
});

export { OnboardingSingleContactPopup };
export default OnboardingSingleContactPopup;
